export const MAX_IMAGE_FILE_BYTES = 10 * 1024 * 1024;

type ImageFileLike = Pick<File, 'type' | 'size'>;

export type ImageFileValidation = { ok: true } | { ok: false; message: string };

export function validateImageFile(file: ImageFileLike): ImageFileValidation {
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
    return { ok: false, message: '只支持 JPG、PNG、WebP 图片' };
  }
  if (file.size > MAX_IMAGE_FILE_BYTES) {
    const size = `${(file.size / 1024 / 1024).toFixed(2)}MB`;
    return { ok: false, message: `图片大小为 ${size}（${file.size.toLocaleString('en-US')} 字节），超过 10MB 上限，请压缩后重试` };
  }
  return { ok: true };
}
